import { render, staticRenderFns } from "./ChecklistAdd.vue?vue&type=template&id=463c9830&scoped=true&"
import script from "./ChecklistAdd.vue?vue&type=script&lang=js&"
export * from "./ChecklistAdd.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistAdd.vue?vue&type=style&index=0&id=463c9830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463c9830",
  null
  
)

export default component.exports